/**
 * Fixed header on scroll
 */
import $ from 'jquery';
import { $document, $win } from '../utils/globals';

$win.on('scroll', function() {
	const header = $('.header');

	header.toggleClass('has-solid-background', $win.scrollTop() > 20);
	header.toggleClass('is-sticky', $win.scrollTop() > 20);
})
